<template>
  <div class="app-bar-component">
    <v-tooltip bottom v-if="permissaoPabx">
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon 
          color="orangePcm" 
          href="/pabx" 
          target="_blank" 
          v-bind="attrs" 
          v-on="on"
          @click="goToPabx"
          :class = "isActive(`/pabx`)"
          :disabled = "isButtonDisabled(`/pabx`)"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <span>PABX</span>
    </v-tooltip>

    <v-tooltip bottom v-if="permissaoRelatorioPabx">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="orangePcm"
          href="/relatorios-pabx"
          target="_blank"
          v-bind="attrs"
          v-on="on"
          @click="goToRelatoriosPabx"
          :class = "isActive(`relatorios-pabx`)"
          :disabled = "isButtonDisabled(`relatorios-pabx`)"
        >
          <v-icon>mdi-clipboard-check-outline</v-icon>
        </v-btn>
      </template>
      <span>Relatórios PABX</span>
    </v-tooltip>

    <v-tooltip bottom v-if="permissaoMonitorRamais">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="orangePcm"
          href="/monitor-ramais"
          target="_blank"
          v-bind="attrs"
          v-on="on"
          @click="goToMonitorOnly"
          :class = "isActive(`/monitor-ramais`)"
          :disabled = "isButtonDisabled(`/monitor-ramais`)"
        >
          <v-icon>mdi-monitor</v-icon>
        </v-btn>
      </template>
      <span>Monitor de Ramais</span>
    </v-tooltip>

    <v-tooltip bottom v-if="permissaoCallCenter">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="orangePcm"
          href="/central-de-atendimento"
          target="_blank"
          v-bind="attrs"
          v-on="on"
          @click="goToCallCenter"
          :class = "isActive(`/central-de-atendimento|/monitor-filas|/monitor-operador`)"
          :disabled = "isButtonDisabled(`/central-de-atendimento`)"
        >
          <v-icon>mdi-phone-message</v-icon>
        </v-btn>
      </template>
      <span>Central de Atendimento</span>
    </v-tooltip>

    <v-tooltip bottom v-if="permissaoPesquisaSatisfacao">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="orangePcm"
          href="/pesquisa-satisfacao"
          target="_blank"
          v-bind="attrs"
          v-on="on"
          @click="goToSatisfactionResearch"
          :class = "isActive(`/pesquisa-satisfacao`)"
          :disabled = "isButtonDisabled(`/pesquisa-satisfacao`)"
        >
          <v-icon>mdi-text-box-search</v-icon>
        </v-btn>
      </template>
      <span>Pesquisa de Satisfação</span>
    </v-tooltip>

    <v-tooltip bottom v-if="permissaoUsuarios">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="orangePcm"
          href="/controle-de-acesso"
          target="_blank"
          v-bind="attrs"
          v-on="on"
          @click="goToAccessControl"
          :class = "isActive(`/controle-de-acesso`)"
          :disabled = "isButtonDisabled(`/controle-de-acesso`)"
        >
          <v-icon>mdi-account-lock</v-icon>
        </v-btn>
      </template>
      <span>Controle de Acesso</span>
    </v-tooltip>

    <v-tooltip bottom v-if="numberOfPermissions > 1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon 
          color="orangePcm" 
          href="/select" 
          target="_blank" 
          v-bind="attrs" 
          v-on="on" 
          @click="backToLobby"
        >
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </template>
      <span>Selecionar Módulo</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon color="orangePcm" 
          v-bind="attrs" 
          v-on="on" 
          @click="logoff"
        >
          <v-icon>mdi-power-standby</v-icon>
        </v-btn>
      </template>
      <span>Deslogar</span>
    </v-tooltip>
  </div>
</template>

<script>
import { logoutMethod } from '@/utils/commomMethods/logoutMethod'
import { appBarMixins } from '@/mixins/appBarMixins'

export default {
  name: 'AppBarUser',

  mixins: [appBarMixins],

  methods: {
    ...logoutMethod,
    isActive(rota){
    let test = new RegExp(rota, 'g');
      if(this.$route.path.match(test)){
        return "indigo darken-1"
      }
    },
    isButtonDisabled(rota){
      let test = new RegExp(rota, 'g');
      if(this.$route.path.match(test)){
        return true
      }
    }
  },
  
}
</script>

<style scoped>
.app-bar-component {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
